// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","chatLayout":"_1ndoICoze1GeTrXvaBLcJi","chat":"BnsOCqwYtBLgSGpkb5tRl","emptyIndexText":"_3JU3O-EmTDiZXeoZOYQq2s"};